/* eslint-disable import/prefer-default-export */
export const extractParagraphText = (html: string) => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, 'text/html');
  const paragraph = doc.querySelector('p');
  if (paragraph?.textContent) return paragraph.textContent.trim();
  return '';
};
